export default "__VITE_ASSET__HKXe11kD__"